import React from 'react';
import ContactCard from './ContactCard';
import ContactCardEdit from './ContactCardEdit';


const ListUserCards = (props) => {
  if (props.contactCards.length < 1) {
    return (
      <div>...</div> // TODO -- add error handling here
    )
  }


  return [{}].concat(props.contactCards).map(
    (onePerson, i) =>
      i === 0
        ? null
        : onePerson._source.app ==='exaContact' ?
          <ContactCardEdit
            key={onePerson._source.contactId}
            person={onePerson}
            // changed={props.changed( event, onePerson.id )}
            // changed={( event ) => this.props.changed( event, onePerson.id )}
          />
          : <ContactCard
              key={onePerson._source.exaId}
              person={onePerson}
            />
  );
}

export default ListUserCards;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ListUserCards.js